import { createGenerateClassName } from '@material-ui/core/styles';
import { SheetsRegistry } from 'react-jss/lib/jss';
import { muiTheme as theme } from './theme';

function createContext() {
    return {
        theme,
        // This is needed in order to inject the critical CSS.
        sheetsRegistry: new SheetsRegistry(),
        generateClassName: createGenerateClassName(),
    };
}

export default function getContext() {
    // Make sure to create a new store for every server-side request so that data
    // isn't shared between connections (which would be bad)
    if (!process.browser) {
        return createContext();
    }

    // Reuse context on the client-side
    if (!global.__INIT_MATERIAL_UI__) {
        global.__INIT_MATERIAL_UI__ = createContext();
    }

    return global.__INIT_MATERIAL_UI__;
}




// WEBPACK FOOTER //
// ./src/themeContext.js